import { Attr, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type PermissionsRole from "./PermissionsRole";

@Model()
class Role extends ApplicationRecord {
  static jsonapiType = "roles";

  @Attr() name: string;

  @HasMany() permissionsRoles: PermissionsRole[];

  @Attr() position: number;

  @Attr() product: string;
}

export default Role;
